import { render } from "./ProductGallery.vue?vue&type=template&id=0e6fc79b&scoped=true"
import script from "./ProductGallery.vue?vue&type=script&lang=js"
export * from "./ProductGallery.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0e6fc79b"

export default script